// extracted by mini-css-extract-plugin
export default {"dropdownButton":"faq-item_dropdownButton__f7cER","dropdown":"faq-item_dropdown__VoBjK","faqItem":"faq-item_faqItem__m44Sl","open-content":"faq-item_open-content__tYFGZ"};